import { Injectable } from '@angular/core';
import {Http, RequestOptions, Headers} from "@angular/http";
import {ConnectionService} from "./connection.service";
import {Observable} from "rxjs/Observable";
import {ResourceStatistic} from "../entities/ResourceStatistic";
import {Resource} from "../entities/Resource";
import {AppConfig} from "../app.config";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class ResourceStatsService {

  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/ResourceStat/';
  }

  getAllUserHours(fromDate : Date, toDate : Date) : Observable<ResourceStatistic> {
    let resourStat = new ResourceStatistic();
    resourStat.fromDate = fromDate.toISOString();
    resourStat.toDate = toDate.toISOString();
    resourStat.Resources = [];
    return this.requestInterceptor
      .post(this.apiUrl + "GetResStats", JSON.stringify(resourStat), this.getHeaders() )
      .map(response => response.json() as ResourceStatistic);
  }

  getAllUserInfo(){
    return this.requestInterceptor
      .get(this.apiUrl + "GetResInfo", this.getHeaders() )
      .map(response => response.json() as Resource[]);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/resource-stats.service.ts